import {
  SUBMIT_FEEDBACK_REQUEST,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR,
  SUBMIT_FEEDBACK_ERROR_MSG,
  SUBMIT_FEEDBACK_SUCCESS_MSG,
  RESET_FEEDBACK
} from "../constants/action-types";

export const defaultFeedbackState = {
  isSubmitting: false,
  hasSubmitted: false,
  isSuccess: false,
  successMsg: SUBMIT_FEEDBACK_SUCCESS_MSG,
  errorMsg: SUBMIT_FEEDBACK_ERROR_MSG
};

export function reducer(state, { type }) {
  switch (type) {
    case SUBMIT_FEEDBACK_REQUEST:
      return {
        ...state,
        isSubmitting: true
      };
    case SUBMIT_FEEDBACK_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        hasSubmitted: true,
        isSuccess: true
      };
    case SUBMIT_FEEDBACK_ERROR:
      return {
        ...state,
        isSubmitting: false,
        hasSubmitted: true,
        isSuccess: false
      };
    case RESET_FEEDBACK:
      return {
        ...defaultFeedbackState
      };
    default:
      return state;
  }
}
